export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';

export default function setCurrentAccount(payload) {
  return {
    type: SET_CURRENT_ACCOUNT,
    payload,
  };
}
